import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE } from '../constants';

export const NAME = 'AccountReceivable';
export const API_NAME = 'AccountReceivable';
export const EXPORT_FILE_NAME = 'AccountReceivable.xlsx';
export const CRUMB_LABEL_KEY = 'AccountReceivable';

class Accounting extends BaseApi {
	constructor() {
		super(DMS_MODULE, API_NAME);
	}

	async AccountReceivable(CustomerId:number | null, WorkshopId: number, FromDate: any, ToDate: any) {
		return this.fetch(`/${DMS_MODULE}/${API_NAME}?CustomerId=${CustomerId}&WorkshopId=${WorkshopId}&FromDate=${FromDate}&ToDate=${ToDate}`);
	}

	async settle(dto: any) {
		return this.post(`/${DMS_MODULE}/${API_NAME}/SettleAccount`, dto);
	}

	async reverse(dto: any) {
		return this.post(`/${DMS_MODULE}/${API_NAME}/ReverseSettlement`, dto);
	}
}

export const apiProvider = new Accounting();
